import {Box, Container, List, ListItem, ListItemIcon, Typography} from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Ambulancia from "../../assets/Home/Recurso 8.webp";

const BrandAmbulancia = () => {

  const items = {
    lista:  [
      {text: "Traslados programados locales y foráneos", href: null},
      {text: "Urgencias Avanzadas", href: null},
      {text: "Cuidados Intensivos",href: null},
    ],
    boton: [
      {text: "(311) 211 9470 / (311) 214 0083  / Ext. 162",href: "tel: 3112119470",}
    ]
  }

  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        marginTop: "32px",
        overflow: "hidden",
        backgroundColor: "#18246B",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          padding: "22px 0"
        }}
      >
        <Box sx={{
          display:"flex", 
          flexDirection: {xs: "column", md:"row"}
        }}>
          <Box
            alignContent="center"
            align="center"
            color="white"
            height="inherit"
            sx={{
              width: "100%",
          }}>
            <Typography variant="h2" sx={{fontSize:{xs:"32px", sm:"36px", md:"40px"}}}>Servicio de Ambulancia</Typography>
            <List>
              {items.lista?.map((item, index) => (
                <ListItem key={index} sx={{ alignItems: "baseline", padding:"6px 16px", justifyContent:{xs:"center", sm:"unset"}}}>
                  <ListItemIcon style={{ minWidth: "20px" }}>
                    <FiberManualRecordIcon
                      sx={{ fontSize: "10px", color: "white" }}
                    />
                  </ListItemIcon>
                  <Typography variant="h4" sx={{fontSize:{xs:"16px", sm:"22px", md:"25px"}}}>{item.text}</Typography>
                </ListItem>
              ))}

              <Box sx={{
                width:"100%",
                mt: {xs:"16px", sm:"26px", md:"32px"},
              }}>
                {items.boton?.map((btn, index) =>(
                  <Box component="a" key={index} href={btn.href} target="_blank" sx={{
                    margin: "0px",
                    lineHeight: "1.334",
                    textAlign: "center",
                    backgroundColor: "rgb(6, 199, 249)",
                    color: "rgb(255, 255, 255)",
                    borderRadius: "5px",
                    fontWeight: "700",
                    textDecoration: "none",
                    padding: {xs:"6px", sm:"8px", md:"10px"},
                    fontSize: {xs:"12px", sm:"16px", md:"18px"},
                    '&:hover': {
                      backgroundColor: "#15ce21",
                      transition: "1s"
                    },
                  }}>
                    {btn.text}
                  </Box> 
                ))}
              </Box>
            </List>
          </Box>

          <Box sx={{
            width: {xs:"40%", sm:"45%", md:"80%"},
            alignSelf: "center",
          }}>
            <Box
              component="img"
              src={Ambulancia}
              alt="Banner"
              loading="lazy"
              sx={{
                width: "100%",
                objectFit: "fill",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default BrandAmbulancia;
